<template>
  <block-view style="flex: 1; width: calc(100% - 440px)">
    <a-breadcrumb>
      <a-breadcrumb-item v-for="i in main.active.args.path.map(e => material.tags.tags[e].name).slice(0,2)" :key="i">
        {{ i }}
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div class="filter-row" v-for="(cs, i) in main.active.components" :key="i">
      <scroll-pager-view>
        <a-space :size="16">
          <div class="item" v-for="mo in cs" :key="mo.tag"
               :class="{'active':main.active.args.path[i+2]==mo.tag}"
               @click="main.onFilterChanged(i+2,mo.tag)">
            {{ mo.name }}
          </div>
        </a-space>
      </scroll-pager-view>
    </div>

    <a-tabs v-if="main.active.scenes.length" :active-key="main.active.args.path.last()" type="card" :tab-bar-gutter="8"
            class="ts" @change="main.onTabChange($event)">
      <a-tab-pane v-for="i in main.active.scenes" :key="i.tag" :tab="i.name"/>
    </a-tabs>
    <waterfall v-if="main.active.themes.length > 0" :list="main.active.themes" :breakpoints="main.breakPoint"
               :ref="(el)=> setRefMap(el)">
      <template #item="{item}">
        <template-card-view :tc="item" @on-load="imgOnLoad"/>
      </template>
    </waterfall>
    <a-empty v-else/>
  </block-view>
</template>

<script setup lang="ts">

import BlockView from "@/views/share/BlockView.vue";
import {ref} from "vue";
import ScrollPagerView from "@/views/share/ScrollPagerView.vue";
import {Waterfall} from "vue-waterfall-plugin-next";
import 'vue-waterfall-plugin-next/dist/style.css'
import TemplateCardView from "@/views/main/segments/TemplateCardView.vue";
import {useRoute} from "vue-router";
import {Main} from "@/model/main";
import {Material} from "@/model/material";

const route = useRoute()
const main = useRoute().meta.main as Main
const material = route.meta.material as Material


const wf: any = ref()
const setRefMap = (el: any) => {
  wf.value = el
}

const imgOnLoad = () => {
  wf.value.renderer()
}
</script>

<style lang="sass">
@import "@/main.variable"
.ts
  .ant-tabs-tab-active
    background: $color-primary !important

    .ant-tabs-tab-btn
      color: #fff !important
</style>

<style scoped lang="sass">
@import "@/main.variable"

.filter-row
  display: flex
  flex-flow: row nowrap
  justify-content: flex-start
  margin: 28px 0

  > .title
    flex-shrink: 0
    width: 66px

  > div
    margin: auto 0

  .item
    flex-shrink: 0
    cursor: pointer
    min-width: 68px
    padding: 7px 19px
    border: 1px solid #e9e9e9
    border-radius: 8px
    color: #333
    font-size: 14px
    display: flex
    margin: 0 20px
    align-items: center
    width: max-content
    min-height: 42px

    > span
      font-size: 24px
      margin: auto
      color: gray


  .ant-space
    > .ant-space-item

      > .item
        margin: 0

      > .festival
        cursor: pointer
        display: flex
        flex-flow: row nowrap
        justify-content: space-between
        border-radius: 8px
        border: 1px solid #e8eaec
        width: 280px
        height: 68px
        padding: 20px 26px

        > .left
          display: inline-block

          > div
            &:first-child
              font-size: 12px
              font-weight: 400

            &:last-child
              color: gray
              padding-top: 6px

        > .right
          display: inline-block
          margin: auto 0
          font-size: 16px

          > .anticon
            color: $color-primary
            padding-right: 6px


.active
  border: 1px solid $color-primary !important
  background-color: $color-primary !important
  color: white !important

  > span
    color: white !important

  .left > div:last-child
    color: white !important

</style>